import { formatISO, isToday } from 'date-fns';
import moment from 'moment';
import { ExpirationDate } from './public-api';

export const getCurrentFormattedUtcDate = (): string => {
  return formatISO(new Date());
};

export const getCurrentUtcDate = (): string => {
  const currentDate = new Date();
  return currentDate.toISOString();
};

export const getUTCDate = (date: string | number | Date) => {
  const newDate = new Date(date);
  const utcDate = new Date(
    newDate.getUTCFullYear(),
    newDate.getUTCMonth(),
    newDate.getUTCDate(),
  );
  return utcDate;
};

export const getUTCTimezoneDate = (date: Date): Date => {
  const utcDate = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
  );

  return utcDate;
};

export const getFormattedUTCDate = (date?: Date): string => {
  let localTimeDate = date;

  // If no date provided, default to current date and time.
  // If payment date is today, override the provided date with current date and time, to ensure we have the current time.
  // The payment date selector component sets the date to the selected day but sets the time to midnight, so it causes issues when converting to UTC
  const dateValue = new Date(date);
  if (date == null || isToday(dateValue)) {
    localTimeDate = new Date();
  }

  const utcDate = getUTCTimezoneDate(localTimeDate);

  return utcDate.toISOString();
};

export function isDateInPast(month: number, year: number): boolean {
  const utcNow = moment.utc();
  const currentMonth = utcNow.month() + 1; // moment months are 0-based
  const currentYear = utcNow.year();
  return year < currentYear || (year === currentYear && month < currentMonth);
}

export function getExpirationDateObject(
  expirationDate: string,
): ExpirationDate {
  if (!expirationDate) {
    return null;
  }

  const expirationDateReformated = moment(expirationDate, 'MMYYYY', true);

  return {
    expirationMonth: expirationDateReformated.month() + 1,
    expirationYear: expirationDateReformated.year(),
  };
}

export const dateHelper = {
  getCurrentUtcDate: getCurrentUtcDate,
};

export function concatCurrentTimeToDate(date: Date): Date {
  const time = new Date();
  time.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());

  return time;
}
